import moment from "moment";
import numeral from "numeral";
import { dayOfWeek } from "../../../utils/setting";
const timeBlock = [];
for (let i = 7; i <= 11; i++) {
  timeBlock.push(`${i}:00 AM`);
}
timeBlock.push(`12:00 PM`);
for (let i = 1; i <= 10; i++) {
  timeBlock.push(`${i}:00 PM`);
}
function getFormatDate(date) {
  return moment(date).format("DD/MM/YYYY");
}
function getDayOfWeek(datetime) {
  let datesOfWeek = {
    sunday: [],
    monday: [],
    tuesday: [],
    wednesday: [],
    thursday: [],
    friday: [],
    saturday: [],
  };
  for (let i = 0; i < moment(datetime, "YYYYMM").daysInMonth(); i++) {
    let index = moment(datetime, "YYYYMM").add(i, "days").format("e");
    datesOfWeek[dayOfWeek[index]] = datesOfWeek[dayOfWeek[index]].concat(
      moment(datetime, "YYYYMM").add(i, "days").format("DD")
    );
  }
  return datesOfWeek;
}
function getPercentInTime(listOrder, listEmployee) {
  let res = 0;
  listOrder.forEach((order) => {
    let employees = [];
    let deduplicateEmployees = [];
    order.item.forEach((item) => {
      employees = employees.concat(item.employee);
    });
    employees.forEach((i) => {
      if (!deduplicateEmployees.find((e) => e.userCode === i.userCode)) {
        deduplicateEmployees.push(i);
      }
    });
    res += deduplicateEmployees.length / listEmployee.length;
  });

  return res / listOrder.length;
}
function getPercent(
  arrDay,
  fromTime,
  toTime,
  datetime,
  listOrders,
  listEmployee
) {
  let result = 0;
  arrDay.forEach((day) => {
    let from = `${datetime} ${day}, ${fromTime}`;
    let to = `${datetime} ${day}, ${toTime}`;
    from = new Date(moment(from, "YYYYMM DD, h:mm a")).getTime();
    to = new Date(moment(to, "YYYYMM DD, h:mm a")).getTime();
    let ordersInTime = listOrders.filter((order) => {
      let processingTime = order.actionHistory.find(
        (item) => item.status == "new"
      );
      if (processingTime)
        return from < processingTime.time && processingTime.time < to;
      return false;
    });
    if (ordersInTime.length > 0)
      result += getPercentInTime(ordersInTime, listEmployee);
  });
  return result / arrDay.length;
}

export default function (data) {
  let today = moment(new Date()).format("DD/MM/YYYY  h:mm A");
  let datesOfWeek = getDayOfWeek(data.datetime);
  let time = [];
  timeBlock.reduce((item1, item2) => {
    let monday = getPercent(
      datesOfWeek.monday,
      item1,
      item2,
      data.datetime,
      data.listOrders,
      data.listEmployee
    );
    let tuesday = getPercent(
      datesOfWeek.tuesday,
      item1,
      item2,
      data.datetime,
      data.listOrders,
      data.listEmployee
    );
    let wednesday = getPercent(
      datesOfWeek.wednesday,
      item1,
      item2,
      data.datetime,
      data.listOrders,
      data.listEmployee
    );
    let thursday = getPercent(
      datesOfWeek.thursday,
      item1,
      item2,
      data.datetime,
      data.listOrders,
      data.listEmployee
    );
    let friday = getPercent(
      datesOfWeek.friday,
      item1,
      item2,
      data.datetime,
      data.listOrders,
      data.listEmployee
    );
    let saturday = getPercent(
      datesOfWeek.saturday,
      item1,
      item2,
      data.datetime,
      data.listOrders,
      data.listEmployee
    );
    let sunday = getPercent(
      datesOfWeek.sunday,
      item1,
      item2,
      data.datetime,
      data.listOrders,
      data.listEmployee
    );
    let total =
      (monday + tuesday + wednesday + thursday + friday + saturday + sunday) /
      7;
    time.push({
      duration: `${item1}-${item2}`,
      monday: monday,
      tuesday: tuesday,
      wednesday: wednesday,
      thursday: thursday,
      friday: friday,
      saturday: saturday,
      sunday: sunday,
      total: total,
    });
    return item2;
  });
  let totalAllTime = {
    sunday: 0,
    monday: 0,
    tuesday: 0,
    wednesday: 0,
    thursday: 0,
    friday: 0,
    saturday: 0,
    total: 0,
  };
  time.forEach((item) => {
    totalAllTime.monday += item.monday;
    totalAllTime.tuesday += item.tuesday;
    totalAllTime.wednesday += item.wednesday;
    totalAllTime.thursday += item.thursday;
    totalAllTime.friday += item.friday;
    totalAllTime.saturday += item.saturday;
    totalAllTime.sunday += item.sunday;
    totalAllTime.total += item.total;
  });
  for (let key in totalAllTime) {
    totalAllTime[key] /= time.length;
  }
  let timeBlockRow = [
    [
      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: "Block Time",
                bold: true,
                alignment: "left",
                margin: [0, 0, 0, 0],
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function (i, node) {
            return i === node.table.body.length ? 1 : 0;
          },
          vLineWidth: function (i, node) {
            return 0;
          },
          hLineColor: function (i, node) {
            return i === node.table.body.length
              ? "#E8E9EC"
              : "rgba(41, 47, 72, 0)";
          },
          // vLineColor: function (i, node) {
          //     return (i === 0 || i === node.table.widths.length) ? 'black' : 'gray';
          // },
        },
        margin: [0, 16, 0, 0],
      },
      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: data.t("report_monday"),
                bold: true,
                alignment: "right",
                margin: [0, 0, 0, 0],
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function (i, node) {
            return i === node.table.body.length ? 1 : 0;
          },
          vLineWidth: function (i, node) {
            return 0;
          },
          hLineColor: function (i, node) {
            return i === node.table.body.length
              ? "#E8E9EC"
              : "rgba(41, 47, 72, 0)";
          },
          // vLineColor: function (i, node) {
          //     return (i === 0 || i === node.table.widths.length) ? 'black' : 'gray';
          // },
        },
        margin: [0, 16, 0, 0],
      },
      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: data.t("report_tuesday"),
                bold: true,
                alignment: "right",
                margin: [0, 0, 0, 0],
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function (i, node) {
            return i === node.table.body.length ? 1 : 0;
          },
          vLineWidth: function (i, node) {
            return 0;
          },
          hLineColor: function (i, node) {
            return i === node.table.body.length
              ? "#E8E9EC"
              : "rgba(41, 47, 72, 0)";
          },
          // vLineColor: function (i, node) {
          //     return (i === 0 || i === node.table.widths.length) ? 'black' : 'gray';
          // },
        },
        margin: [0, 16, 0, 0],
      },
      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: data.t("report_wednesday"),
                bold: true,
                alignment: "right",
                margin: [0, 0, 0, 0],
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function (i, node) {
            return i === node.table.body.length ? 1 : 0;
          },
          vLineWidth: function (i, node) {
            return 0;
          },
          hLineColor: function (i, node) {
            return i === node.table.body.length
              ? "#E8E9EC"
              : "rgba(41, 47, 72, 0)";
          },
          // vLineColor: function (i, node) {
          //     return (i === 0 || i === node.table.widths.length) ? 'black' : 'gray';
          // },
        },
        margin: [0, 16, 0, 0],
      },
      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: data.t("report_thursday"),
                bold: true,
                alignment: "right",
                margin: [0, 0, 0, 0],
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function (i, node) {
            return i === node.table.body.length ? 1 : 0;
          },
          vLineWidth: function (i, node) {
            return 0;
          },
          hLineColor: function (i, node) {
            return i === node.table.body.length
              ? "#E8E9EC"
              : "rgba(41, 47, 72, 0)";
          },
          // vLineColor: function (i, node) {
          //     return (i === 0 || i === node.table.widths.length) ? 'black' : 'gray';
          // },
        },
        margin: [0, 16, 0, 0],
      },
      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: data.t("report_friday"),
                bold: true,
                alignment: "right",
                margin: [0, 0, 0, 0],
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function (i, node) {
            return i === node.table.body.length ? 1 : 0;
          },
          vLineWidth: function (i, node) {
            return 0;
          },
          hLineColor: function (i, node) {
            return i === node.table.body.length
              ? "#E8E9EC"
              : "rgba(41, 47, 72, 0)";
          },
          // vLineColor: function (i, node) {
          //     return (i === 0 || i === node.table.widths.length) ? 'black' : 'gray';
          // },
        },
        margin: [0, 16, 0, 0],
      },
      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: data.t("report_saturday"),
                bold: true,
                alignment: "right",
                margin: [0, 0, 0, 0],
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function (i, node) {
            return i === node.table.body.length ? 1 : 0;
          },
          vLineWidth: function (i, node) {
            return 0;
          },
          hLineColor: function (i, node) {
            return i === node.table.body.length
              ? "#E8E9EC"
              : "rgba(41, 47, 72, 0)";
          },
          // vLineColor: function (i, node) {
          //     return (i === 0 || i === node.table.widths.length) ? 'black' : 'gray';
          // },
        },
        margin: [0, 16, 0, 0],
      },
      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: data.t("report_sunday"),
                bold: true,
                alignment: "right",
                margin: [0, 0, 0, 0],
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function (i, node) {
            return i === node.table.body.length ? 1 : 0;
          },
          vLineWidth: function (i, node) {
            return 0;
          },
          hLineColor: function (i, node) {
            return i === node.table.body.length
              ? "#E8E9EC"
              : "rgba(41, 47, 72, 0)";
          },
          // vLineColor: function (i, node) {
          //     return (i === 0 || i === node.table.widths.length) ? 'black' : 'gray';
          // },
        },
        margin: [0, 16, 0, 0],
      },
      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: data.t("report_total"),
                bold: true,
                alignment: "right",
                margin: [0, 0, 0, 0],
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function (i, node) {
            return i === node.table.body.length ? 1 : 0;
          },
          vLineWidth: function (i, node) {
            return 0;
          },
          hLineColor: function (i, node) {
            return i === node.table.body.length
              ? "#E8E9EC"
              : "rgba(41, 47, 72, 0)";
          },
          // vLineColor: function (i, node) {
          //     return (i === 0 || i === node.table.widths.length) ? 'black' : 'gray';
          // },
        },
        margin: [0, 16, 0, 0],
      },
    ],
  ];
  time.map((item) => {
    timeBlockRow.push([
      {
        text: `${item.duration}`,
        alignment: "left",
        margin: [0, 16, 0, 0],
      },
      {
        text: `${Math.round(item.monday * 100)} %`,
        alignment: "right",
        margin: [0, 16, 0, 0],
      },
      {
        text: `${Math.round(item.tuesday * 100)} %`,
        alignment: "right",
        margin: [0, 16, 0, 0],
      },
      {
        text: `${Math.round(item.wednesday * 100)} %`,
        alignment: "right",
        margin: [0, 16, 0, 0],
      },
      {
        text: `${Math.round(item.thursday * 100)} %`,
        alignment: "right",
        margin: [0, 16, 0, 0],
      },
      {
        text: `${Math.round(item.friday * 100)} %`,
        alignment: "right",
        margin: [0, 16, 0, 0],
      },
      {
        text: `${Math.round(item.saturday * 100)} %`,
        alignment: "right",
        margin: [0, 16, 0, 0],
      },
      {
        text: `${Math.round(item.sunday * 100)} %`,
        alignment: "right",
        margin: [0, 16, 0, 0],
      },
      {
        text: `${Math.round(item.total * 100)} %`,
        alignment: "right",
        margin: [0, 16, 0, 0],
      },
    ]);
  });
  timeBlockRow.push([
    {
      text: data.t("report_total_all_time"),
      alignment: "left",
      bold: true,
      margin: [0, 0, 0, 0],
    },
    {
      text: `${Math.round(totalAllTime.monday * 100)} %`,
      alignment: "right",
      bold: true,
      margin: [0, 0, 0, 0],
    },
    {
      text: `${Math.round(totalAllTime.tuesday * 100)} %`,
      alignment: "right",
      bold: true,
      margin: [0, 0, 0, 0],
    },
    {
      text: `${Math.round(totalAllTime.wednesday * 100)} %`,
      alignment: "right",
      bold: true,
      margin: [0, 0, 0, 0],
    },
    {
      text: `${Math.round(totalAllTime.thursday * 100)} %`,
      alignment: "right",
      bold: true,
      margin: [0, 0, 0, 0],
    },
    {
      text: `${Math.round(totalAllTime.friday * 100)} %`,
      alignment: "right",
      bold: true,
      margin: [0, 0, 0, 0],
    },
    {
      text: `${Math.round(totalAllTime.saturday * 100)} %`,
      alignment: "right",
      bold: true,
      margin: [0, 0, 0, 0],
    },
    {
      text: `${Math.round(totalAllTime.sunday * 100)} %`,
      alignment: "right",
      bold: true,
      margin: [0, 0, 0, 0],
    },
    {
      text: `${Math.round(totalAllTime.total * 100)} %`,
      alignment: "right",
      bold: true,
      margin: [0, 0, 0, 0],
    },
  ]);
  return {
    info: {
      title: "ReportEmployee",
      author: "Masspa",
      subject: "Report",
      keywords: "keywords for document",
    },
    content: [
      {
        columns: [
          {
            // % width
            width: "50%",
            alignment: "left",
            text: today,
          },
          {
            // % width
            width: "50%",
            alignment: "right",
            text: "Masspa 0.0.1",
          },
        ],
        // optional space between columns
        columnGap: 10,
      },
      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: "",
                border: [false, false, false, true],
                margin: [0, 16, 0, 0],
              },
            ],
          ],
        },
      },
      {
        text: data.t("report_employee_report"),
        style: "header",
        margin: [0, 16, 0, 0],
      },
      {
        text: `${data.t("report_report_for")}: ${getFormatDate(
          data.from
        )} - ${getFormatDate(data.to)}`,
        alignment: "center",
        fontSize: 14,
        margin: [0, 6, 0, 16],
      },
      {
        table: {
          widths: [
            "20%",
            "10%",
            "10%",
            "10%",
            "10%",
            "10%",
            "10%",
            "10%",
            "10%",
          ],
          body: timeBlockRow,
        },
        layout: {
          hLineWidth: function (i, node) {
            return 0;
          },
          vLineWidth: function (i, node) {
            return 0;
          },
          // hLineColor: function (i, node) {
          //     return (i === node.table.body.length) ? 'rgba(41, 47, 72, 0.15)' : 'rgba(41, 47, 72, 0)';
          // },
          // vLineColor: function (i, node) {
          //     return (i === 0 || i === node.table.widths.length) ? 'black' : 'gray';
          // },
        },
      },
    ],
    styles: {
      header: {
        fontSize: 24,
        bold: true,
        color: "#ff513f",
        alignment: "center",
      },
      title: {
        fontSize: 12,
        bold: true,
        color: "#292f48",
        alignment: "center",
      },
      anotherStyle: {
        italics: true,
        alignment: "right",
      },
    },
    defaultStyle: {
      fontSize: 12,
      bold: false,
      color: "#292f48",
    },
    // a string or { width: number, height: number }
    pageSize: "A4",

    // by default we use portrait, you can change it to landscape if you wish
    pageOrientation: "landscape",

    // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
    pageMargins: [24, 24, 24, 24],
  };
}
